<template>
    <div>
        <div class="display flex wrap center vcenter">
            <p v-if="data?.status?.description === 'nocredential'">پیکربندی تلفن متعلق به کاربر یافت نشد!</p>
            <input v-else ref="destination" id="destination" type="mobile" v-model="models['destination']" @keydown="(event) => {
                if (event.key === 'Enter')
                    this.$refs.answer.click()
                else if (tones.hasOwnProperty(event.key)) {
                    DTMF(event.key, 200)
                    if (data?.status?.dialpad)
                        $emit('dialpad', event.key)
                }
            }" autofocus>
        </div>
        <div class="numpad flex wrap center vcenter">
            <div class="flex wrap center">
                <template v-for="(item, index) in numpad" :key="index">
                    <div class="flex wrap center vcenter" @click.prevent="() => {
                        if (data?.status?.description !== 'nocredential') {
                            models['destination'] = `${models['destination'] || ''}${item['num']}`
                            if (!mobile)
                                this.$refs.destination.focus()

                            if (data?.status?.dialpad)
                                $emit('dialpad', item['num'])
                        }
                    }" @mouseup="() => {
                        tone.osc1.stop()
                        tone.osc2.stop()
                    }" @mousedown="() => DTMF(item['num'], 0)" @mouseleave="() => {
                        tone.osc1?.stop()
                        tone.osc2?.stop()
                    }">
                        <h6>{{ item['num'] }}</h6>
                        <p>{{ item['char'] }}</p>
                    </div>
                </template>
            </div>
        </div>
        <div class="actions flex wrap center vcenter">
            <img v-if="String(this.models['destination'] || '').length > 0" class="backspace"
                :class="[{ 'forward': data?.status?.forward }]" v-lazy="'/images/backspace.webp'" width="42" height="42"
                alt="backspace" loading="lazy" @click.prevent="() => {
                    this.models['destination'] = String(this.models['destination']).slice(0, this.models['destination'].length - 1)
                }">
            <img v-if="data?.status?.dialpad || data?.status?.forward" v-lazy="'/images/xmark.webp'" width="42"
                height="42" alt="x" loading="lazy" @click.prevent="$emit('cancel')">
            <img v-if="data?.status?.registration && !data?.status?.dialpad" ref="answer" v-lazy="'/images/answer.webp'"
                width="42" height="42" alt="answer" loading="lazy" @click.prevent="() => {
                    if (data?.status?.forward) {
                        models['destination'] = ''
                        $emit('forward')
                    }
                    else
                        $emit('call')
                }">
        </div>
    </div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'Dial',
    props: ['data'],
    computed: {
        did() {
            return this.data?.did
        }
    },
    data() {
        return {
            models: {
                destination: this.did || ''
            },
            context: new (window.AudioContext || window.webkitAudioContext)(),
            numpad: [
                { num: '1', char: '@' },
                { num: '2', char: 'ABC' },
                { num: '3', char: 'DEF' },
                { num: '4', char: 'GHI' },
                { num: '5', char: 'JKL' },
                { num: '6', char: 'MNO' },
                { num: '7', char: 'PQRS' },
                { num: '8', char: 'TUV' },
                { num: '9', char: 'WXYZ' },
                { num: '*', char: '' },
                { num: '0', char: '+' },
                { num: '#', char: '' },
            ],
            tone: {
                osc1: null,
                osc2: null
            },
            tones: {
                '1': [697, 1209],
                '2': [697, 1336],
                '3': [697, 1477],
                '4': [770, 1209],
                '5': [770, 1336],
                '6': [770, 1477],
                '7': [852, 1209],
                '8': [852, 1336],
                '9': [852, 1477],
                '0': [941, 1336],
                '*': [941, 1209],
                '#': [941, 1477]
            },
            mobile: window.screen.width <= 430
        }
    },
    watch: {
        did(newDID, oldDID) {
            this.models['destination'] = this.did
        },
        models: {
            handler(newHandler, oldHandler) {
                this.$emit('onchange', {
                    value: this.models['destination']
                })
            },
            deep: true
        }
    },
    methods: {
        DTMF(digit, duration = 200) {
            const freqs = this.tones[digit]
            if (!freqs)
                return
            const gainNode = this.context.createGain()
            gainNode.connect(this.context.destination)
            gainNode.gain.setValueAtTime(0.1, this.context.currentTime)

            const osc1 = this.context.createOscillator()
            const osc2 = this.context.createOscillator()

            osc1.type = 'sine'
            osc2.type = 'sine'

            osc1.frequency.setValueAtTime(freqs[0], this.context.currentTime)
            osc2.frequency.setValueAtTime(freqs[1], this.context.currentTime)

            osc1.connect(gainNode)
            osc2.connect(gainNode)

            osc1.start()
            osc2.start()

            if (duration > 0)
                this.tone = setTimeout(() => {
                    osc1.stop()
                    osc2.stop()
                }, duration)
            else {
                this.tone.osc1 = osc1
                this.tone.osc2 = osc2
            }

        }
    }
}
</script>

<style scoped src="../../assets/css/components/phone/dial.css"></style>
<style scoped src="../../assets/css/components/phone/dial_dark.css"></style>